/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Manage_Copilot_Disable_DescInputs */



/**
* | output |
* | --- |
* | "Copilot stays active until {date}, then it is disabled." |
*
* @param {Partner_Manage_Copilot_Disable_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_disable_desc = /** @type {((inputs: Partner_Manage_Copilot_Disable_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_Disable_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Copilot bleibt bis zum ${i?.date} aktiv und wird dann deaktiviert.`)
	return /** @type {LocalizedString} */ (`Copilot stays active until ${i?.date}, then it is disabled.`)
});